module.exports = __webpack_public_path__ + "static/media/document-week8.11d710c9.pdf";